"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserFullName = exports.emptyUser = exports.IdentificationType = exports.HoursRegistrationType = void 0;
var moment = require("moment");
var _1 = require(".");
var HoursRegistrationType;
(function (HoursRegistrationType) {
    HoursRegistrationType["NORM"] = "norm";
    HoursRegistrationType["OPTIONAL"] = "optional";
    HoursRegistrationType["NOT_ALLOWED"] = "not-allowed";
})(HoursRegistrationType = exports.HoursRegistrationType || (exports.HoursRegistrationType = {}));
var IdentificationType;
(function (IdentificationType) {
    IdentificationType["ID"] = "id";
    IdentificationType["PASSPORT"] = "passport";
})(IdentificationType = exports.IdentificationType || (exports.IdentificationType = {}));
exports.emptyUser = {
    _id: null,
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    rate: 0,
    role: _1.UserRoles.DEFAULT,
    type: _1.UserType.PORTAL,
    identification: {
        type: IdentificationType.ID,
        idNumber: '',
        validUntil: moment().toDate(),
        SSN: '',
        nationality: '',
        burgerServiceNumber: '',
    },
    settings: {
        company: [],
    },
    signature: {
        date: null,
    },
    address: {
        streetName: '',
        houseNumber: '',
        houseNumberExtension: '',
        postCode: '',
        place: '',
    },
    isActive: true,
};
var getUserFullName = function (user, appendUsername) {
    if (appendUsername === void 0) { appendUsername = false; }
    var fullname = "".concat((user === null || user === void 0 ? void 0 : user.firstName) || (user === null || user === void 0 ? void 0 : user.username)).concat((user === null || user === void 0 ? void 0 : user.lastNamePrefix) ? (' ' + (user === null || user === void 0 ? void 0 : user.lastNamePrefix)) : '', " ").concat((user === null || user === void 0 ? void 0 : user.lastName) || '');
    if (appendUsername) {
        fullname += " [".concat(user === null || user === void 0 ? void 0 : user.username, "]");
    }
    return fullname;
};
exports.getUserFullName = getUserFullName;
